<template>

    <div class="cc-4-l widget-simple-text">

        <!-- If loading -->
        <div class="cc-loader " v-if="loading">
            <div class="spinner"></div>
        </div>

        <!-- else -->
        <div v-else>
            <div v-if="!errored" class="cc-fs-25">
                {{ title }}
            </div>
            <div v-else>
                <i class="fas fa-spider-black-widow icon-left" aria-hidden></i>
                NewsApi.org down ?
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    const api = 'http://evene.lefigaro.fr/rss/citation_jour.xml'
//

    export default {
        name: 'News',
        data() {
            return {
                title: '',
                errored: false,
                loading: true,
            }
        },
        mounted () {

            var config = {
                headers: {'Access-Control-Allow-Origin': '*'}
            };

            // Set final Api with website
            // this.finalApi = api.replace('__##__', encodeURI(this.website));

            // Get Google Insight score
            axios
                .get(api,config)
                .then(response => {
                    console.log(response.data)
                    this.title = response.data.articles[0].title;
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    this.loading = false
                })
        },
    }
</script>


<style scoped lang="less">
</style>
